import React from 'react';

import { BooleanInput, required } from 'react-admin';

import { Box } from '@mui/material';

import SmartDateInput from '../../../../customFields/SmartDateInput';
import isPastDate from '../../../utils/reports/isPastDate';
import dateRangeValidation from '../../../utils/reports/dateRangeValidation';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const AccountFirstInitiator = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Date range" description="Report start and end date (inclusive, CET timezone). Both dates are required.">
      <RangeFields
        from={(
          <SmartDateInput fullWidth validate={[required(), isPastDate, dateRangeValidation]} source="report.from" label="From *" helperText={false} />
        )}
        to={(
          <SmartDateInput fullWidth validate={[required(), dateRangeValidation]} source="report.to" label="To *" helperText={false} />
        )}
      />
    </FieldBox>
    <FieldBox title="Include country data" description="Include a country-level aggregated sheet in the output." inline>
      <BooleanInput source="report.countryLevelData" label="" helperText={false} defaultValue />
    </FieldBox>
    <FieldBox title="Include raw data" description="Include a per-account country-indicator sheet in the output." inline>
      <BooleanInput source="report.includeRawTable" label="" helperText={false} defaultValue={false} />
    </FieldBox>
  </Box>
);

export default AccountFirstInitiator;
